import {NgModule} from '@angular/core';
import {SharedProviderModule} from '../../shared/shared.module';
import {NotificationComponent} from './notification.component';
import {NotificationService} from './notification.service';
import {CommentService} from './comment/comment.service';
import {QmPipesModule} from '../qm-pipes/qm-pipes.module';
import {QmDirectivesModule} from '../qm-directives/qm-directives.module';
import {OverlayPanelModule} from '../overlay-panel/overlay-panel.module';
import {VivoNotificationComponent} from './new-notification/vivo-notification/vivo-notification.component';
import {WhiteboardComponent} from './new-notification/whiteboard/whiteboard.component';
import {NotificationTypesComponent} from './new-notification/notification-types/notification-types.component';
import { NgbTabsetModule, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import {NguiAutoCompleteModule} from '@ngui/auto-complete';
import { FlagService } from '../../shared/flag/flag.service';


/**
 * Module for SliderComponent
 */
@NgModule({
  imports: [
    QmPipesModule,
    SharedProviderModule,
    QmDirectivesModule,
    OverlayPanelModule,
    NgbTabsetModule,
    NgbTypeaheadModule,
    NguiAutoCompleteModule,
    NgbTooltipModule
  ],
  exports: [NotificationComponent, NotificationTypesComponent, VivoNotificationComponent],
  declarations: [
    NotificationComponent,
    VivoNotificationComponent,
    WhiteboardComponent,
    NotificationTypesComponent,
  ],
  providers: [NotificationService, CommentService, FlagService]
})
export class NotificationModule {
}
